module.exports = __webpack_public_path__ + "img/reject_rd_gray_70@2x.d045bbc7.png";